import moment from 'moment/moment';
import i18n from '../../services/i18n.js';

// Validaciones segun OLYB2B-304
// fromDate, toDate
// Nuevas reglas OLYB2B-492

export const handleDateChange = (target, value, self) => {
    let obj = { ...self.state.filters };
    if (target === 'toDate') {
        //valido fecha hasta
        let dif = value.diff(obj.fromDate, 'days');
        if (dif < 0) {
            alert(i18n.t('ALERT.DATA_RANGE_FROM_TO_WRONG'));
            return;
        }
    } else { // From Date.
        let dif = value.diff(obj.toDate, 'hours');
        if (dif > 0){
            obj.toDate = moment(value).add(1, 'days');
        }
    }
    obj[target] = value;
    self.setState({ filters: obj });
};


// WEBPACK FOOTER //
// ./src/components/Utils/handleDateChange.js